// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function ErrorFieldText(props) {
  var error = props.error;
  if (error !== undefined) {
    return JsxRuntime.jsx("div", {
                children: error,
                className: Cn.make([
                      "block text-xs text-left mt-1 mb-2 text-prezzee-red",
                      Belt_Option.getWithDefault(props.className, "")
                    ])
              });
  } else {
    return null;
  }
}

var make = ErrorFieldText;

export {
  make ,
}
/* react/jsx-runtime Not a pure module */
